<template>
    <aside class="sidebar">
            <router-link to="/" class="sidebar-logo">
                <img src="/logo2.png" alt="Logo" style="height: 30px;">
                <span>EXPAT VISA</span>
            </router-link>
            <nav>
                <ul class="sidebar-nav">
                    <a href="#" @click.prevent="irAAreaPrivada">
                        <ion-icon name="document-text-outline"></ion-icon> 
                        <span>Mis Pólizas</span>
                    </a>
                    <li><router-link :to="{name: 'area-admin', params: { lang: currentLang }}">
                        <ion-icon name="people-outline"></ion-icon>
                        <span>Usuarios admin</span>
                    </router-link></li>
                    <li>
                        <router-link :to="{ name: 'vencimientos' }">
                            <ion-icon name="calendar-outline"></ion-icon> 
                            <span>Vencimientos</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'soporte' }">
                            <ion-icon name="help-circle-outline"></ion-icon> 
                            <span>Soporte</span>
                        </router-link>
                    </li>
                </ul>
            </nav>
            <div class="sidebar-footer">
                <ul class="sidebar-nav">
                    <li><a href="#" @click.prevent="cerrarSesion">
                        <ion-icon name="log-out-outline"></ion-icon> 
                        <span>Cerrar Sesión</span>
                    </a></li>
                </ul>
            </div>
        </aside>
</template>

<script>
    export default{
        computed: {
            currentLang() {
                return this.$route.params.lang || 'es'
            }
        },
        methods:{
            irAAreaPrivada() {
                const currentLang = this.$route.params.lang || 'es'
                this.$router.push({ name: 'AreaPrivada', params: { lang: currentLang } })
                setTimeout(() => {
                    window.location.reload()
                }, 100)
            },
            cerrarSesion() {
                localStorage.removeItem('expat_visa_session')
                localStorage.removeItem('user')
                localStorage.removeItem('user_name')
                localStorage.removeItem('user_rol')
                this.$router.push({ name: 'login' })
                setTimeout(() => {
                    window.location.reload()
                }, 100)
            }
        }
    }
</script>

<style scoped>
    /* ========== SIDEBAR ========== */
.sidebar {
    width: 260px;
    background: white;
    border-right: 1px solid #e1e4e8;
    padding: 30px 20px;
    display: flex;
    flex-direction: column;
    position: fixed;
    height: 100vh;
    overflow-y: auto;
}

.sidebar-logo {
    display: flex;
    align-items: center;
    gap: 12px;
    text-decoration: none;
    margin-bottom: 40px;
    font-weight: 700;
    color: #1C4A8D;
    font-size: 1.1rem;
}

.sidebar-nav {
    list-style: none;
    padding: 0;
    margin: 0;
}

.sidebar-nav li {
    margin-bottom: 8px;
}

.sidebar-nav a {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 15px;
    color: #5f6368;
    text-decoration: none;
    border-radius: 8px;
    transition: all 0.2s;
    font-weight: 500;
}

.sidebar-nav a:hover,
.sidebar-nav a.active {
    background-color: #f1f3f9;
    color: #1C4A8D;
}

.sidebar-nav ion-icon {
    font-size: 1.4rem;
}

.sidebar-footer {
    margin-top: auto;
    padding-top: 20px;
    border-top: 1px solid #e1e4e8;
}
</style>